/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/
import * as escrowDatastoreCollections from '@escrow/datastore/collections';
import * as escrowDocumentCreators from '@escrow/datastore/collections-testing/document-creators';
import * as escrowPushTransformers from '@escrow/datastore/collections-testing/push-transformers';

export const datastoreFunctions = {
  customerWebhooksReducer: escrowDatastoreCollections.customerWebhooksReducer,
  defaultDisbursementMethods:
    escrowDatastoreCollections.defaultDisbursementMethods,
  createCustomerWebhook: escrowDocumentCreators.createCustomerWebhook,
  createCustomer: escrowDocumentCreators.createCustomer,
  createDisbursementMethod: escrowDocumentCreators.createDisbursementMethod,
  createDisbursementMethods: escrowDocumentCreators.createDisbursementMethods,
  createSearchTransaction: escrowDocumentCreators.createSearchTransaction,
  createTransferAccountBalances:
    escrowDocumentCreators.createTransferAccountBalances,
  createSearchTransactions: escrowDocumentCreators.createSearchTransactions,
  addPushTransformers: escrowPushTransformers.addPushTransformers,
  addCustomerWebhookComputedFields:
    escrowPushTransformers.addCustomerWebhookComputedFields,
};
